export const RUN_PENDENTE = 1;
export const RUN_EXECUTANDO = 2;
export const RUN_CONCLUIDO = 3;
export const RUN_ERRO = 4;
export const RUN_PULADO = 5;

export interface InfraSubpasso {
    nome: string;
    situacao: number;
    /** Quando o subpasso começou, no formato dd/mm/aaaa hh:mm:ss. */
    inicio: string | null;
    local: string | null;
    comando: string | null;
    saida: string | null;
    ms: number | null;
}

export interface InfraRun {
    id: number;
    /** Só a tentativa aberta vem com subpassos; as outras são só o chip. */
    carregado: boolean;
    numero: number;
    situacao: number;
    inicio: string | null;
    ms: number | null;
    erro: string | null;
    parametros: any;
    usuario: string | null;
    subpassos: Array<InfraSubpasso>;
}

export interface InfraHistorico {
    success: boolean;
    chave: string;
    /** Subpassos que o passo declara que vai executar, na ordem. */
    roteiro: Array<string>;
    rotulo: string;
    resumo: string;
    destino: string;
    depende: Array<string>;
    runs: Array<InfraRun>;
}

export interface InfraParametro {
    chave: string;
    rotulo: string;
    valor: string | number | null;
    proposta: string | number | null;
    explicacao: string | null;
    efetivo: string | number | null;
    consumidoPor: string | null;
    editavel: boolean;
    motivoTrava: string | null;
}

/** Duração legível: passo de 40ms não deve aparecer como 0s. */
export const duracao = (ms: number | null | undefined): string => {
    if (ms === null || ms === undefined) {
        return '';
    }
    if (ms < 1000) {
        return ms + 'ms';
    }
    if (ms < 60000) {
        return (ms / 1000).toFixed(1) + 's';
    }
    const minutos = Math.floor(ms / 60000);
    const segundos = Math.round((ms % 60000) / 1000);
    return minutos + 'm' + (segundos > 0 ? ' ' + segundos + 's' : '');
};

export const marcadorSituacao = (situacao: number): string => {
    switch (situacao) {
        case RUN_CONCLUIDO: return '✓';
        case RUN_ERRO: return '✕';
        case RUN_EXECUTANDO: return '…';
        case RUN_PULADO: return '⤼';
        default: return '·';
    }
};

export const classeSituacao = (situacao: number): string => {
    switch (situacao) {
        case RUN_CONCLUIDO: return 'ok';
        case RUN_ERRO: return 'erro';
        case RUN_EXECUTANDO: return 'executando';
        case RUN_PULADO: return 'pulado';
        default: return 'pendente';
    }
};
